import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Label, SpecraButton, SpecraInput, SpecraOverlayDialog, SpecraTextarea } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/authContext';
import { tenantRootRef } from '../../lib/access/useTenantAreas';
import { useView } from '../../lib/access/useView';
import { useCreateCaptureProject } from './hooks';
/**
 * "New Pursuit" trigger + create dialog (GRW-14: extracted from
 * CaptureListPage so the legacy list and the Pursuits list share it). The
 * trigger is disabled without capture_project create at the tenant root;
 * success opens the new pursuit. Testids are unchanged.
 */ export function NewPursuitDialog({ triggerLabel = 'New Pursuit' }) {
    const navigate = useNavigate();
    const { user } = useAuth();
    const createAccess = useView(tenantRootRef(user?.tenant_id ?? '', 'capture_project'), {
        action: 'create',
        enabled: !!user?.tenant_id
    });
    const create = useCreateCaptureProject();
    const [open, setOpen] = useState(false);
    const [name, setName] = useState('');
    const [hypothesis, setHypothesis] = useState('');
    const submit = ()=>{
        if (!name.trim()) return;
        create.mutate({
            name: name.trim(),
            opportunityHypothesis: hypothesis.trim()
        }, {
            onSuccess: (summary)=>{
                setOpen(false);
                setName('');
                setHypothesis('');
                navigate(`/capture/${summary.captureProjectId}`);
            }
        });
    };
    return /*#__PURE__*/ _jsx(SpecraOverlayDialog, {
        open: open,
        onOpenChange: setOpen,
        title: "New Pursuit",
        testId: Testids.capture.createDialog,
        trigger: /*#__PURE__*/ _jsx(SpecraButton, {
            disabled: !createAccess.can('create'),
            "data-testid": Testids.capture.newButton,
            children: triggerLabel
        }),
        footerProps: {
            confirmLabel: create.isPending ? 'Creating…' : 'Create',
            onConfirm: submit,
            confirmProps: {
                disabled: !name.trim() || create.isPending,
                'data-testid': Testids.capture.createSubmitButton
            }
        },
        children: /*#__PURE__*/ _jsxs("div", {
            className: "space-y-4 py-2",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "space-y-2",
                    children: [
                        /*#__PURE__*/ _jsx(Label, {
                            htmlFor: "capture-name",
                            children: "Name"
                        }),
                        /*#__PURE__*/ _jsx(SpecraInput, {
                            id: "capture-name",
                            value: name,
                            onChange: (e)=>setName(e.target.value),
                            placeholder: "Agency X recompete",
                            "data-testid": Testids.capture.createNameInput
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "space-y-2",
                    children: [
                        /*#__PURE__*/ _jsx(Label, {
                            htmlFor: "capture-hypothesis",
                            children: "Opportunity hypothesis"
                        }),
                        /*#__PURE__*/ _jsx(SpecraTextarea, {
                            id: "capture-hypothesis",
                            value: hypothesis,
                            onChange: (e)=>setHypothesis(e.target.value),
                            placeholder: "Why this is worth pursuing…",
                            "data-testid": Testids.capture.createHypothesisInput
                        })
                    ]
                })
            ]
        })
    });
}
